import React, { Fragment } from 'react';
import { withRouter } from 'react-router-dom'
import { useStateIfMounted } from 'use-state-if-mounted'
const { useState, useEffect, useRef } = React;
import { Paper, Typography } from '@mui/material';
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import { faClosedCaptioning } from '@fortawesome/free-solid-svg-icons';
const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 800,
    height: 530,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    color: 'black',
    p: 4,
    'overflowY': 'scroll',
};
const ModalDetalleMotivos = (props) => {


    let texto = props.texto
    const { api = undefined } = props
    const { VerModalDetalle, dataDetalle, detalleMotivo = undefined } = api
    /******Modal */
    const [openModal, setOpenModal] = React.useState(detalleMotivo);
    const [titleModal, setTitleModal] = React.useState('');
    const [bodyModal, setBodyModal] = React.useState('')
    const [accion, setAccion] = React.useState('')

    const handleCloseModal = () => {
        setTitleModal('')
        setBodyModal('')
        setAccion('')
        setOpenModal(false)
        VerModalDetalle(false)
        //resetValores({ validacion: false, texto: '' })
    }

    return (
        <Modal open={openModal} onClose={handleCloseModal} aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description" hideBackdrop={true} >
            <Box sx={style}>
                <Typography id="modal-modal-title" variant="h6" component="h2" style={{ color: "black", textAlign: 'center' }}>
                    Motivos de Certificado
                </Typography>
                <Typography id="modal-modal-description" component="h2" sx={{ mt: 2 }} style={{ color: "black", textAlign: 'center' }}>
                    <Fragment>
                        <div className='row' >
                            {dataDetalle.vencimientocertificado && <Fragment>
                                <div className='col-5' style={{ textAlign: 'start' }}>
                                    <label className='text-start'> Vencimiento de certificado </label>
                                </div>
                                <div className='col-7'> </div><hr /></Fragment>
                            }

                            {dataDetalle.cambioaduana &&
                                <Fragment>
                                    <div className='col-5' style={{ textAlign: 'start' }}>
                                        <label className='text-start'> Cambio de aduana: </label>
                                    </div>
                                    <div className='col-7'>
                                        <textarea type="textarea" rows='1' className={`form-control`}
                                            id="" value={dataDetalle.especificaraduana} disabled />
                                    </div><hr />
                                </Fragment>
                            }
                            {dataDetalle.cambiocatidad && <Fragment>
                                <div className='col-5' style={{ textAlign: 'start' }}>
                                    <label className='text-start'> Cambio de la cantidad del producto: </label>
                                </div>
                                <div className='col-7'>
                                    <textarea type="textarea" rows='1' className={`form-control`}
                                        id="" placeholder='especificardestinatario' name="especificardestinatario"
                                        value={dataDetalle.especificarcantidad} disabled />
                                </div><hr />
                            </Fragment>}
                            {dataDetalle.cambiodestinatario &&
                                <Fragment>
                                    <div className='col-5' style={{ textAlign: 'start' }}>
                                        <label className='text-start'> Cambio de destinatario: </label>
                                    </div>
                                    <div className='col-7'>
                                        <textarea type="textarea" rows='1' className={`form-control`}
                                            id="" placeholder='especificardestinatario' name="especificardestinatario"
                                            value={dataDetalle.especificardestinatario} disabled />
                                    </div><hr />
                                </Fragment>}
                            {dataDetalle.domicilioimportador && <Fragment>
                                <div className='col-5' style={{ textAlign: 'start' }}>
                                    <label className='text-start'> Cambio de domicilio del importador: </label>
                                </div>
                                <div className='col-7'>
                                    <textarea type="textarea" rows='1' className={`form-control`}
                                        id="" placeholder='especificardestinatario' name="especificardestinatario" 
                                        value={dataDetalle.especificardomicilio} disabled/>
                                </div><hr />
                            </Fragment>}
                            {dataDetalle.otros && <Fragment>
                                <div className='col-5' style={{ textAlign: 'start' }}>
                                    <label className='text-start'>Otros: </label>
                                </div>
                                <div className='col-7'>
                                    <textarea type="textarea" rows='1' className={`form-control`}
                                        id="" placeholder='especificardestinatario' name="especificardestinatario" 
                                        value={dataDetalle.especificarotros} disabled/>
                                </div><hr />
                            </Fragment>}

                        </div>
                    </Fragment>
                </Typography>
                <br />
                <div className='text-center'>
                    <button className={`btn btn-success`} type='button' style={{ width: '50%' }} onClick={() => handleCloseModal()}>Cerrar</button>
                </div>
            </Box>
        </Modal>
    )
};

export default withRouter(ModalDetalleMotivos)
